export const GA_MEASUREMENT_ID = "G-YN85P7RH1F";

const canTrack = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

export const trackPageView = ({ path, title }) => {
  if (!canTrack()) {
    return;
  }

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_title: title || document.title,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!canTrack()) {
    return;
  }

  window.gtag("event", eventName, params);
};
